import React from "react";
import { CheckIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { volumes } from "../../data/volumes";
export function Volumes() {
  return <Section className="bg-white" data-id="element-300" data-mp="2wzyqwed3n2ix">
      <SectionHeading eyebrow="Introducing the Pediatric Articulation Clinical Blueprint™" title="Six practical volumes to help you organize your speech sound planning workflow" intro={<>
            <p data-id="element-302" data-mp="2j9d78nftmojz">
              Each volume focuses on a different task, from organizing observations to preparing activities and
              documenting follow-up.
            </p>
            <p className="mt-2" data-id="element-303" data-mp="29bpchxi7th1t">
              The goal is to give you a practical educational reference you can return to as you organize your work.
            </p>
          </>} data-id="element-301" data-mp="2x34h5wxgsag8" />

      <div className="mt-12 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-304" data-mp="25bx2dgd6b2uc">
        {volumes.map(v => <article key={v.n} className={`flex flex-col rounded-3xl p-6 sm:p-8 ${v.soft}`} data-id="element-305" data-mp="20dddp8773cya">
            <div className="flex items-center gap-3" data-id="element-306" data-mp="333t69q91prbz">
              <span className={`flex h-14 w-14 shrink-0 flex-col items-center justify-center rounded-2xl ${v.badge}`} data-id="element-307" data-mp="37xe5flmdkrcr">
                <span className="text-[9px] font-extrabold uppercase leading-none tracking-wider" data-id="element-308" data-mp="2u6iw687ys88n">Vol</span>
                <span className="font-display text-2xl font-bold leading-none" data-id="element-309" data-mp="2y6sz1c0gmija">{v.n}</span>
              </span>
              <h3 className="font-display text-[22px] font-bold leading-tight text-navy" data-id="element-310" data-mp="3lu17u3x3k9q2">{v.title}</h3>
            </div>
            <p className="mt-5 font-display text-lg font-semibold leading-snug text-navy" data-id="element-311" data-mp="3cvfnc382ekmn">{v.tagline}</p>
            <p className="mt-2 text-[16px] leading-relaxed text-ink/80" data-id="element-312" data-mp="3hua8hbti8l9x">{v.body}</p>
            <p className="mt-5 text-sm font-extrabold uppercase tracking-wide text-ink/70" data-id="element-313" data-mp="21ga9c32hgznq">Inside, you'll find</p>
            <ul className="mt-3 space-y-2" data-id="element-314" data-mp="26f3qc5gzb8sn">
              {v.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] font-semibold leading-snug text-ink" data-id="element-315" data-mp="bz59pf6htx53">
                  <CheckIcon className={`mt-0.5 h-5 w-5 shrink-0 ${v.check}`} strokeWidth={3} aria-hidden="true" data-id="element-316" data-mp="6zjz27hyo0cj" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-auto pt-6 text-[15px] italic leading-relaxed text-ink/75" data-id="element-317" data-mp="3ude5mzqhotft">{v.closing}</p>
          </article>)}
      </div>

      <p className="mt-12 text-center font-display text-2xl font-bold text-navy" data-id="element-318" data-mp="3peumt876zxro">
        Six practical volumes. One organized educational collection.
      </p>
      <div className="mt-8" data-id="element-319" data-mp="3ffc1oofjq5y1">
        <CTAButton label="Get all six volumes" data-id="element-320" data-mp="3fgn5go8zrdp5" />
      </div>
    </Section>;
}